// Aplica el tope "cantidad_maxima" (por repuesto_id, viene del catálogo vía la plantilla) a una
// lista ORDENADA de líneas de repuesto. Las líneas con `_fijarDecision: true` no se reevalúan
// (se respeta su `ya_incluido` tal cual, ya decidido antes por el usuario o por el servidor) pero
// sí acumulan cantidad si no están excluidas. Las demás se deciden: si sumar su cantidad al
// acumulado supera el menor "cantidad_maxima" visto hasta ahora para ese repuesto_id, quedan
// `ya_incluido: true` con `maximo_excedido` = ese límite. Sin tope declarado, nunca se excluyen.
//
// Kits: `componentesPorKit` es { [repuesto_id_del_kit]: [prefijo, ...] } (ver POST
// /repuestos/componentes; ya trae los prefijos_equivalentes expandidos). Los componentes de un
// kit son PREFIJOS, no repuestos concretos (un mismo empaque puede tener códigos distintos según
// el modelo). Si hay una línea de un kit presente (no rechazada), TODA línea cuyo "codigo" tenga
// uno de esos prefijos queda `ya_incluido` con `incluido_en_kit` = nombre del kit, sin depender
// de cantidad_maxima (el propio kit nunca se excluye a sí mismo). Un segundo kit igual también
// queda `ya_incluido` ("Máximo 1 por trabajo"), aunque no tenga cantidad_maxima de catálogo.
const prefijoDe = (codigo) => String(codigo || "").trim().toUpperCase().split("-")[0];

export function aplicarLimitePorTrabajo(lineas, componentesPorKit = {}) {
  const kitsPresentes = {};  // repuesto_id del kit -> nombre (de su propia línea)
  lineas.forEach((it) => {
    const rid = it.ref_id || it.repuesto_id;
    if (it.estado !== "rechazado" && componentesPorKit[rid]) kitsPresentes[rid] = it.nombre;
  });
  const prefijoAKit = {};  // prefijo -> nombre del kit que lo incluye
  Object.keys(kitsPresentes).forEach((kitId) => {
    (componentesPorKit[kitId] || []).forEach((pref) => { if (!(pref in prefijoAKit)) prefijoAKit[pref] = kitsPresentes[kitId]; });
  });

  const acumulado = {};
  const maximos = {};
  return lineas.map((it) => {
    const rid = it.ref_id || it.repuesto_id;
    const pref = prefijoDe(it.codigo);
    if (!(rid in kitsPresentes) && pref && pref in prefijoAKit) {
      if (it._fijarDecision) return it;
      return { ...it, ya_incluido: true, maximo_excedido: null, incluido_en_kit: prefijoAKit[pref] };
    }
    if (it.cantidad_maxima != null) {
      maximos[rid] = maximos[rid] != null ? Math.min(maximos[rid], it.cantidad_maxima) : it.cantidad_maxima;
    }
    if (rid in kitsPresentes) {  // el propio kit: máximo 1 por trabajo aunque no tenga máximo de catálogo
      maximos[rid] = maximos[rid] != null ? Math.min(maximos[rid], 1) : 1;
    }
    const limite = maximos[rid];
    const previo = acumulado[rid] || 0;
    const cant = Number(it.cantidad) || 1;
    if (it._fijarDecision) {
      if (!it.ya_incluido) acumulado[rid] = previo + cant;
      return it;
    }
    if (limite != null && previo + cant > limite + 1e-9) {
      return { ...it, ya_incluido: true, maximo_excedido: limite, incluido_en_kit: null };
    }
    acumulado[rid] = previo + cant;
    return { ...it, ya_incluido: false, maximo_excedido: null, incluido_en_kit: null };
  });
}
